import { IPIconButton, IPTooltipHost } from 'baseComponents';
import { useTranslation } from 'react-i18next';

export interface PreviewToggleProps {
  previewDismissed?: boolean;
  onTogglePreview: () => void;
  previewToggleId?: string;
}

const PreviewToggle = (props: PreviewToggleProps) => {
  const { t } = useTranslation(['kpis']);

  return (
    <span
      id={props.previewToggleId ?? 'fieldPreviewToggle'}
      style={{
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        left: -8,
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 1,
      }}
    >
      <IPTooltipHost
        content={props.previewDismissed ? t('kpis:Dialogs.Preview.ShowButton') : t('kpis:Dialogs.Preview.HideButton')}
      >
        <IPIconButton
          iconProps={{ iconName: props.previewDismissed ? 'ChevronLeft' : 'ChevronRight' }}
          ariaLabel={
            props.previewDismissed ? t('kpis:Dialogs.Preview.ShowButton') : t('kpis:Dialogs.Preview.HideButton')
          }
          onClick={props.onTogglePreview}
        />
      </IPTooltipHost>
    </span>
  );
};

export default PreviewToggle;
